import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual } from 'helpers/utils'



export const TableExpanded = React.memo((props) => {
    const { row } = props;
    const { config } = props;
    const data = (row)
        ? row.extendedResults.filter(row => row.er_code === 'INTERMEDIATE')
        : undefined

    let numCols = findArray(config, { ei_code: ['INTERMEDIATES_TOTAL'] })
    let bestAttemp = row?.extendedResults && findArray(row.extendedResults, { er_code: ['BEST_ATTEMPT_NUM'] }).er_value
    let rowsTr = []
    for (let i = 0; i < numCols.ei_value; i++) {
        let pos = i + 1;
        //   let res = findObject2(data, 'er_code', 'INTERMEDIATE', 'er_pos', z.toString())


        let intermediate = findArray(data, { er_pos: [pos.toString()] })
        let wind = intermediate?.extensions && findArray(intermediate.extensions, { ere_code: ['WIND_SPEED'] }).ere_value
        rowsTr.push(
            <tr key={'expanded_' + row.participant.code + '_' + i}>
                <td>{pos}</td>
                <td className={intermediate.er_pos === bestAttemp ? 'fw-bold text-success' : ''}>
                    {!!intermediate.er_value
                        ?
                        <div className={"d-flex flex-column"} >
                            <span >{intermediate.er_value}</span>
                            <small>{wind}</small>
                        </div>
                        : null
                    }
                </td>

            </tr>

        )
    }

    return (
        <table className="table table-striped table-bordered">
            <thead>
                <tr>
                    <th><Label data="HeaderAttempts" /></th>
                    <th><Label data="HeaderResult" /></th>
                </tr>
            </thead>
            <tbody>
                {rowsTr}
            </tbody>
        </table>

    );
}, (prevProps, nextProps) => {
    //Si retornamos true:  No se renderiza
    //Si retornamos false: Si se renderiza
    return (
        //renderizamos cuando un dato de los visibles cambia
        arraysEqual(prevProps.row.extendedResults, nextProps.row.extendedResults)
        //arraysEqual(prevProps.row, nextProps.row)
    )
});